<template>
  <div class="d-flex align-items-center initiative-activity">
    <b-form-checkbox size="sm" :checked="isClosed" :disabled="true"> </b-form-checkbox>
    <div class="title flex-grow-1 d-flex">
      <div
        class="d-flex justify-content-between flex-nowrap align-items-center flex-grow-1 overflow-hidden"
      >
        <div class="overflow-hidden d-flex align-items-center">
          <span class="text-truncate flex-grow-1" :title="activity.initiative.title" v-no-capture>{{
            activity.initiative.title
          }}</span>
          <action-tooltip :target="'initiative-expander-' + activity.initiative.id" text="Open" />
          <span
            class="expander-icon pointer mx-2"
            :id="'initiative-expander-' + activity.initiative.id"
            @click="goToInitiativePage"
            ><i></i
          ></span>
        </div>
        <div class="d-flex align-items-center">
          <span
            class="text-secondary text-small pl-2 text-nowrap actor"
            v-if="activity.actor.firstName"
            v-no-capture
            >by {{ activity.actor.firstName }}</span
          >
          <span class="text-secondary text-small px-2 text-nowrap time">{{
            getTimeOrDate(activity.createdAt)
          }}</span>
          <user-short length="20" :user-id="ownerId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTimeOrDate } from '@/utils/formatDate'
import handleClickNavigation from '@/utils/handleClickNavigation'
import { getInitiativePageRouteConfig } from '@/utils/navigationConfigs'
import { BFormCheckbox } from 'bootstrap-vue'
import UserShort from '@/components/UserShort'
import ActionTooltip from '@/components/ActionTooltip'

/**
 * This components renders a row of Initiative activity, showing information about the activity.
 * e,g <Initiative_Title> --- by <actorName> --- <Activity_Time>
 */
export default {
  name: 'InitiativeActivityRow',
  props: ['isClosed', 'activity'],
  components: {
    BFormCheckbox,
    UserShort,
    ActionTooltip
  },
  methods: {
    getTimeOrDate,
    goToInitiativePage(event) {
      const initiative = this.activity.initiative
      const location = getInitiativePageRouteConfig({
        orgId: initiative.organizationId,
        initiativeId: initiative.id
      })
      handleClickNavigation.call(this, event, location)
    }
  },
  computed: {
    ownerId() {
      let primaryOwnership = this.activity.initiative.ownerships.find(
        ownership => ownership.isPrimary
      )
      return primaryOwnership ? primaryOwnership.userId : undefined
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.title {
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 6px 0;
}
.actor,
.time {
  padding-top: 2px;
}
.time {
  width: 95px;
  display: inline-block;
  margin-left: 6px;
}
.initiative-activity:not(:last-child) .title {
  border-bottom: 1px solid $borderPrimary;
}
</style>
